import React from "react";

interface Props {
  path: string;
}

const AromTopRightGif: React.FC<Props> = ({ path }) => {
  return (
    <div
      id="TopRightGif"
      style={{
        position: "absolute",
        right: "10px",
        top: "30px",
        display: "none",
      }}
    >
      <img
        style={{
          borderRadius: "20px",
          width: "105px",
          height: "200px",
        }}
        src={path}
        alt="Git animation"
      />
    </div>
  );
};

export default AromTopRightGif;
